import api from '@/utils/api'

export default {
    getMatches(page, size, query) {
        let filter = null
        if (Object.values(query).length > 0) {
            filter = Object.values(query).reduce((total, value) => total + `, ${value}`)
            // keys without braces ("round":"3", "league":"5") are ignored by the server: an object is needed
            if (!/^\s*[[{]/.test(filter)) {
                filter = `{${filter}}`
            }
        }
        const sort = '&sort=' + encodeURIComponent('[matchDatetime, DESC]')
        const range = '?range=' + encodeURIComponent(`[${page - 1},${size}]`)
        return api.get('matches' + (page ? range : '') + (filter ? `&filter=${encodeURIComponent(filter)}` : '') + sort)
    },

    getMatchesByTeam(id, query, phase, leagueId = null) {
        let filter = (phase === 'cup' ? 'isCup=true' : '')
        if (query) {
            if (Object.values(query).length > 0) {
                filter = Object.values(query).reduce((total, value) => total + `&${value}`)
            }
        }
        let queryParams = (phase && phase !== 'cup') ? `?phase=${phase}&` : ('?' + filter ? `?${filter}` : '')
        if (leagueId && phase !== 'cup') {
            queryParams += `${queryParams.endsWith('&') || queryParams === '?' ? '' : '&'}leagueId=${leagueId}`
        }
        return api.get(`matches/team/${id}` + queryParams)
    },

    getMatch(id) {
        return api.get(`matches/${id}/stats`)
    },

    getMatchLogs(matchId) {
        return api.get(`matches/${matchId}/logs`)
    },

    getActivePlayers(matchId) {
        return api.get(`matches/${matchId}/active-players`)
    },

    // The live stream page tells the stats operator (CMS) which screen it shows
    reportLiveScreen(matchId, screen) {
        return api.post(`events/${matchId}/screen-state`, { screen })
    }
}
